import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './nl/common'
import errors from './nl/errors'
import success from './nl/success'
import validation from './nl/validation'

export const defaultNS = 'common' as const

export const resources = {
  nl: {
    common,
    errors,
    success,
    validation,
  },
} as const

i18n.use(initReactI18next).init({
  resources,
  lng: 'nl',
  fallbackLng: 'nl',
  defaultNS,
  ns: ['common', 'errors', 'success', 'validation'],
  interpolation: {
    escapeValue: false,
  },
})

export default i18n


